import {computed, ref} from 'vue';
import {CONTENT_RISK_QUALITY, CONTENT_RISK_STATUS} from '../../content-risk.constants';

export default function useGenericRiskActions(fetcher) {
    const risks = ref(null);
    const riskStatus = ref(CONTENT_RISK_STATUS.NONE);

    let requestCounter = 0;

    const sendable = computed(() => {
        return risks.value?.quality !== CONTENT_RISK_QUALITY.SPAM_NOT_SENDABLE;
    });

    const quality = computed(() => {
        return risks.value?.quality ?? CONTENT_RISK_QUALITY.OK;
    });

    const messages = computed(() => {
        return risks.value?.details ?? [];
    });

    const isLoading = computed(() => {
        return riskStatus.value === CONTENT_RISK_STATUS.LOADING;
    });

    const fetch = async (content) => {
        if (!content) {
            return;
        }

        requestCounter++;
        const localCount = requestCounter;

        try {
            riskStatus.value = CONTENT_RISK_STATUS.LOADING;

            const contentRisks = await fetcher(content);

            if (requestCounter !== localCount) {
                return;
            }

            risks.value = contentRisks;
            riskStatus.value = CONTENT_RISK_STATUS.NONE;
        } catch (error) {
            riskStatus.value = CONTENT_RISK_STATUS.FAILED;
        }
    };

    return {
        riskStatus,
        sendable,
        quality,
        messages,
        isLoading,
        fetch,
    };
}
